import React, { useState } from "react";
import DataTable from "../../../Components/UI/table/DataTable";
import { useQuery } from "react-query";

import StatusBadge from "../../../Components/UI/statusBadge";
import TableActions from "../../../Components/UI/table/TableActions";
import {
  deleteSections,
  getSections,
  updateSections,
} from "../../../MyApi/section";
import Can from "../../../utils/can";
import i18next from "i18next";
import HeaderBar from "../../../Components/UI/headerbar";
import StoreSectionModal from "../../systemsettings/sections/storeSections";

const SectionsPage = () => {
  const [isSectionOpen, setIsSectionOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [modalId, setModalId] = useState(null);

  const {
    data: sectionsData,
    refetch: refetchSections,
    isLoading: isSectionLoading,
  } = useQuery(["getSections"], () => getSections());
  const sections = sectionsData?.data?.sections || [];

  const sectionsColumns = [
    {
      label: "اسم القسم",
      render: (row) => (
        <div className="d-flex align-items-center gap-2">
          {row.icon !== null && <img src={row.icon} width={24} height={24} />}
          <div>
            <h6 className="font16">{row.name}</h6>
            <p>#{row.id}</p>
          </div>
        </div>
      ),
    },
    { label: "الاسم المستعار", accessor: "slug" },
    { label: "ترتيب الأقسام", accessor: "sort_order" },
    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge status={row.is_active ? "active" : "inactive"} />
      ),
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          edit={() => handleSectionsOpenModal("edit", row.id)}
          deleteFn={deleteSections}
          id={row.id}
          refetch={refetchSections}
          mutationKey={"deleteSections"}
          deletePermission={"delete_section"}
          editPermission={"update_section"}
          viewPermission={"view_section"}
          togglePermission={"update_section"}
          toggleMutationKey={"toggle-update-section"}
          queryKey={"getSections"}
          toggleFn={(id, status) =>
            updateSections(
              { is_active: status, _method: "PUT", lang: i18next.language },
              id,
            )
          }
          is_active={row.is_active}
        />
      ),
    },
  ];

  const handleSectionsOpenModal = (mode, id) => {
    setIsSectionOpen(true);

    setModalMode(mode);
    setModalId(id);
  };
  const closeSectionsModal = () => {
    setIsSectionOpen(false);
  };
  return (
    <div>
      <HeaderBar title={"فئات المتاجر"} content={"إدارة فئات المتاجر."} />

      {isSectionOpen && (
        <StoreSectionModal
          refetch={refetchSections}
          isOpen={isSectionOpen}
          toggle={closeSectionsModal}
          modalMode={modalMode}
          modalId={modalId}
        />
      )}

        <Can permission={"view_section"}>
          <DataTable
            title={"الأقسام"}
            columns={sectionsColumns}
            data={sections}
            isLoading={isSectionLoading}
            onAddClick={() => handleSectionsOpenModal("add")}
            actionLabel={"إضافة أقسام جديد"}
            createPermission={"create_section"}
          />
        </Can>
    </div>
  );
};

export default SectionsPage;
